import {Component, OnInit, ViewContainerRef} from '@angular/core';
import { environment } from '../environments/environment';
import { AuthenticationService } from './shared/api/authentication/authentication.service';
import { UserService } from './shared/api/resources/user/user.service';
import { SettingsService } from './shared/api/resources/settings/settings.service';
import {ActivatedRoute, Event, NavigationEnd, Params, Router} from '@angular/router';
import { DaterangepickerConfig } from 'ng2-daterangepicker';
import {ToasterService} from './shared/global/toaster.service';
import {LoadingService} from './shared/global/loading.service';
import { Intercom } from 'ng2-intercom/intercom';
import {User} from './shared/api/model/user';
import {AgentService} from './shared/api/resources/agent/agent.service';
import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: []
})
export class AppComponent implements OnInit {
  title = 'Pluralo Agents';
  initialUserLoaded = false;
  settingsLoaded = false;
  url = '';
  urlParams: Params;
  urlTimeout = setTimeout(() => { }, 0);
  appInitialized = false;
  version = environment.version;

  constructor(private _router: Router,
              private _route: ActivatedRoute,
              private _auth: AuthenticationService,
              private _user: UserService,
              private _agent: AgentService,
              private _settings: SettingsService,
              private _loadingService: LoadingService,
              private _daterangepickerOptions: DaterangepickerConfig,
              private _toasterService: ToasterService,
              private _vcr: ViewContainerRef,
              private intercom: Intercom) {

    this._daterangepickerOptions.skipCSS = true;
    this._toasterService.setViewContainer(this._vcr);

    NgbModalRef.prototype['c'] = NgbModalRef.prototype.close;
    NgbModalRef.prototype.close = function (reason: string) {
      const modalBackdrop = document.querySelector('.modal-backdrop');
      const modal = document.querySelector('.modal');

      modalBackdrop && modalBackdrop.classList.remove('show');
      modal && modal.classList.remove('show');
      modalBackdrop && modalBackdrop.classList.add('hide');
      modal && modal.classList.add('hide');
      setTimeout(() => {
        this['c'](reason);
      }, 300);
    };
    NgbModalRef.prototype['d'] = NgbModalRef.prototype.dismiss;
    NgbModalRef.prototype.dismiss = function (reason: string) {
      const modalBackdrop = document.querySelector('.modal-backdrop');
      const modal = document.querySelector('.modal');

      modalBackdrop && modalBackdrop.classList.remove('show');
      modal && modal.classList.remove('show');
      modalBackdrop && modalBackdrop.classList.add('hide');
      modal && modal.classList.add('hide');
      setTimeout(() => {
        this['d'](reason);
      }, 300);
    };

  }

  ngOnInit() {
    this._router.events.subscribe(
      (value: Event) => {
        if (value instanceof NavigationEnd) {
          this.url = value.url;
          if (!this.url.includes('product-detail') && !this.appInitialized) {
            this._initApp();
          } else if (this.url.includes('product-detail')) {
            this.initialUserLoaded = true;
            this.settingsLoaded = true;
          }
        }
      }
    );
  }

  private _initApp() {
    this.appInitialized = true;

    this.intercom.init({
      app_id: 'zetpu2p7',
      platform: 'Agents',
      widget: {
        'activator': '#intercom'
      }
    });

    this._route.queryParams.subscribe(
      (params: Params) => {
        this.urlParams = params;
        clearTimeout(this.urlTimeout);
        this.urlTimeout = setTimeout(() => this._initUser(), 100);
      }
    );
  }

  private async _initUser() {
    if (this.urlParams['token']) {
      this._auth.access_token = this.urlParams['token'];
      this._settings.getAllRequests().subscribe(undefined, undefined, () => { this.settingsLoaded = true; });
      await this._getUserDetails();
      await this._checkSuppliersAndNavigate();
    } else if (!this._user.loaded) {
      window.location.href = environment.authenticationUrl;
      console.error('No token retrieved from url, redirecting...');
    }
  }

  private _getUserDetails(): Promise<User> {
    return new Promise((resolve, reject) => {
      this._user.getUserDetails().subscribe(
        (user: User) => {
          this._user.loadFromWSResponse(user);
          this.initialUserLoaded = true;
          this.intercom.update({
            app_id: 'zetpu2p7',
            user_id: user['id'],
            name: user['name'],
            brandName: user['brandName'],
            email: user['email'],
            platform: 'Agents',
            widget: {
              'activator': '#intercom'
            }
          });
        },
        () => reject('Unable to get user details!'),
        () => resolve(this._user.user)
      );
    });
  }

  private async _checkSuppliersAndNavigate() {
    const suppliers = await this._agent.updateSuppliers(true);
    if (!suppliers || suppliers.length === 0) {
      await this._router.navigate(
        ['/explore'],
        { relativeTo: this._route });
    } else {
      await this._router.navigate(
        ['/experiences'],
        { relativeTo: this._route });
    }
  }

  get userLoaded(): boolean {
    return this._user.loaded;
  }

  set userLoaded(value: boolean) {
    this._user.loaded = value;
  }

  get loading() {
    return this._loadingService.showLoading;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts